import { render, staticRenderFns } from "./navbar-dropdown.vue?vue&type=template&id=980a0622&scoped=true&"
import script from "./navbar-dropdown.vue?vue&type=script&lang=js&"
export * from "./navbar-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./navbar-dropdown.vue?vue&type=style&index=0&id=980a0622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a0622",
  null
  
)

export default component.exports